module.exports = __webpack_public_path__ + "static/media/footer-notifications.7b15c6c3.png";